import { render, staticRenderFns } from "./ButtonLoginSwitch.vue?vue&type=template&id=44419f8a&"
import script from "./ButtonLoginSwitch.vue?vue&type=script&lang=js&"
export * from "./ButtonLoginSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLoginSwitch.vue?vue&type=style&index=0&id=44419f8a&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports